import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=3ea4df95&"
import script from "./Pagination.vue?vue&type=script&lang=js&"
export * from "./Pagination.vue?vue&type=script&lang=js&"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=3ea4df95&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ea4df95')) {
      api.createRecord('3ea4df95', component.options)
    } else {
      api.reload('3ea4df95', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=3ea4df95&", function () {
      api.rerender('3ea4df95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Pagination/Pagination.vue"
export default component.exports